import React from 'react';
import { isNil } from 'lodash';
import { Accordion } from '@lendi-ui/accordion';
import getColour, { ValidHex } from '@lendi-ui/commons/colours';
import { Size } from '@lendi-ui/typography';

import { StorageKey, useAccordionState } from '@funnels/hooks';
import { useAnalytics } from '@funnels/providers';
import { maskPIIFullStory } from '@funnels/utils';

import { AccordionSubHeaderText } from '../../Common/Accordion/style';
import { CardInternalsWrapper, ColouredCircle } from './index.style';

interface ItemAccordionProps {
  title: string;
  isCompleted?: boolean;
  dataComponent?: string;
  initialOpenState?: boolean;
  storageKey: StorageKey;
  headerSubText?: string;
  // just for financial situation accordion
  pr?: Size;
  headerClassName?: string;
}

export const ItemAccordion: React.FunctionComponent<ItemAccordionProps> = (props) => {
  const {
    storageKey,
    title,
    isCompleted,
    dataComponent,
    children,
    initialOpenState,
    pr,
    headerClassName,
    headerSubText,
  } = props;

  const { tracking } = useAnalytics();
  const [accordionState, setAccordionState] = useAccordionState(
    storageKey,
    initialOpenState ? { isOpen: initialOpenState } : null
  );

  const isOpen = accordionState.isOpen;

  const completionIndicatorColor: ValidHex = isCompleted ? getColour('success', 500) : getColour('error', 500);

  const toggleAccordionOpenState = () => {
    setAccordionState({ ...accordionState, isOpen: !isOpen });
    if (!isOpen) {
      tracking?.accordion.expanded({
        name: title,
        position: title,
      });
    } else {
      tracking?.accordion.collapsed({ name: title, position: title });
    }
  };

  return (
    <Accordion data-component={dataComponent} isOpen={isOpen}>
      <Accordion.Header
        onClick={toggleAccordionOpenState}
        after={
          isNil(isCompleted) ? undefined : (
            <ColouredCircle
              data-component="teamview-accordion-head-completion-dot"
              backgroundColour={completionIndicatorColor}
            />
          )
        }
        className={headerClassName}
      >
        {title}
        {headerSubText && <AccordionSubHeaderText>{maskPIIFullStory(headerSubText)}</AccordionSubHeaderText>}
      </Accordion.Header>
      <Accordion.Content>
        <CardInternalsWrapper pr={pr}>{children}</CardInternalsWrapper>
      </Accordion.Content>
    </Accordion>
  );
};
